export default __webpack_public_path__ + "27628befdf603765f5e990f69067dc9a.svg";